export class CodePriceType {
    static STANDARD_COST_PRICEBOOK = 'STANDARD_COST';
    static TRADE_PRICE_PRICEBOOK = 'TRADE_PRICE';
    static RETAIL_PRICE_PRICEBOOK = 'RETAIL_PRICE';
    static ZERO_PRICE_PRICEBOOK = 'ZERO_PRICE';

    static ALL = [CodePriceType.STANDARD_COST_PRICEBOOK, CodePriceType.TRADE_PRICE_PRICEBOOK, CodePriceType.RETAIL_PRICE_PRICEBOOK];
}